import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterId',
})
export class FilterIdPipe implements PipeTransform {
  transform(value: string | undefined, name: string): string {
    return `${name}-filter-${value ?? ''}`;
  }
}
